import classNames from "classnames";

export const getVarianceToneClass = (value: number | null | undefined): string => {
  if (value == null || value === 0) return "text-muted-foreground";
  if (value > 0) return "text-success";
  return "text-danger";
};

export const budgetMonetaryCellClass = "h-full w-full tabular-nums";

// Inner amount text: no `h-full` so the cell renderer's `flex items-center`
// wrapper can vertically center the number. Horizontal alignment is left to the
// caller (e.g. `w-full` / `ag-right-aligned-cell`), preserving existing layout.
const budgetAmountTextClass = "w-full tabular-nums";

export const budgetEstimateAmountClass = (extra?: string) =>
  classNames(budgetAmountTextClass, "text-foreground", extra);

export const budgetActualAmountClass = (extra?: string) =>
  classNames(budgetAmountTextClass, "text-muted-foreground", extra);

export const budgetVarianceAmountClass = (value: number | null | undefined, extra?: string) =>
  classNames(budgetAmountTextClass, getVarianceToneClass(value), extra);
